var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-7-2.625a.874.874 0 0 0-.758.438.875.875 0 0 1-1.515-.876 2.624 2.624 0 1 1 3.148 3.789v.149a.875.875 0 1 1-1.75 0V10c0-.483.392-.875.875-.875a.875.875 0 1 0 0-1.75Zm0 7a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpFilled);
export default __webpack_public_path__ + "static/media/help-filled.6b0d0bb06105999a9a04bff2fc148a99.svg";
export { ForwardRef as ReactComponent };